import { useQuery } from '@tanstack/react-query';

import { getSetupIpaBasicConfig, SETUP_IPA_BASIC_CONFIG_QUERY_KEY } from '../service';

type UseEffectiveDateEnabledResult = {
  isEnabled: boolean;
  isLoading: boolean;
};

// Mesma chave da tela de Configurações Básicas: salvar lá atualiza a flag lida aqui.
export function useEffectiveDateEnabled(): UseEffectiveDateEnabledResult {
  const { data, isLoading } = useQuery({
    queryKey: SETUP_IPA_BASIC_CONFIG_QUERY_KEY,
    queryFn: getSetupIpaBasicConfig,
    select: config => config?.effective_date_enabled === true,
  });

  return { isEnabled: data === true, isLoading };
}
